<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RYXYBp/tc-custom/9781452140834.jpg?1702235577122" alt="This image is the cover for the book Happiness Is . . . 500 Things to Be Happy About"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Happiness Is . . . 500 Things to Be Happy About
      </h1>
      <p class="bookDescription body article font2">
        <b>From <i>New York Times–</i>bestselling authors, an uplifting cartoon collection celebrating life’s simple joys—the perfect gift for friends or family.</b><br/><br/>From Ralph Lazar and Lisa Swerling, famed illustrators and the authors of <i>Me Without You</i>, this adorable gift book illustrates 500 things to be happy about. Happiness is . . . an unexpected bouquet, cheese, fixing something, a good high-five, and so much more! The charming, make-you-smile illustrations hit just the right note—not too sappy, not too sweet—and remind us that there are dozens of things to be happy about every day. A universally appealing book for any little pick-me-up, this cheerful collection is sure to be a hit year after year!<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Swerling, Ralph Lazar
      </h2>
      
      <p class="authorDescription body article">Lisa Swerling and Ralph Lazar are famed illustrators, the authors of the <I>New York Times</I> bestseller <I>Me Without You</I>, and the creators of the internationally beloved brand <I>Happiness Is ...</I> They live in Marin County, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df3907a6